import { render, staticRenderFns } from "./water_fee.vue?vue&type=template&id=74676a44&"
import script from "./water_fee.vue?vue&type=script&lang=js&"
export * from "./water_fee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports